import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { closeRows } from '../data/comparisons';
import { CHECKOUT_URL, GUARANTEE_DAYS, LAUNCH_PRICE_ENDS, PRICE, PRICE_AFTER_LAUNCH, REGULAR_PRICE, UrgencyVariant } from '../data/offer';
const recap = ['The year', 'The week', 'Daily anchors', 'Records', 'The house', 'The person running it'];
type CloseProps = {
  urgency?: UrgencyVariant;
};
export function Close({
  urgency = 'none'
}: CloseProps) {
  return <section aria-labelledby="close-heading" className="w-full bg-sage text-white" data-id="element-57" data-mp="1g85bqo7wmtgp">
      <div className="max-w-4xl mx-auto px-5 sm:px-8 py-16 sm:py-24" data-id="element-58" data-mp="1c8d185yyad8p">
        <h2 id="close-heading" className="font-serif font-black text-3xl sm:text-5xl text-center tracking-tight" data-id="element-59" data-mp="179jq2k74yybp">
          Stop starting over.
        </h2>

        <p className="mt-6 text-white/85 text-base sm:text-lg leading-relaxed text-center max-w-2xl mx-auto" data-id="element-60" data-mp="xa2l64zpkogs">
          You&apos;ve done the hard part for years — the teaching, the driving,
          the reading aloud, the holding it all together. What&apos;s missing
          was never discipline. It was a system that assumed the week would go
          sideways and kept running anyway.
        </p>

        <ul className="mt-8 flex flex-wrap justify-center gap-2" data-id="element-61" data-mp="3qfsiipi67jpy">
          {recap.map(chip => <li key={chip} className="inline-flex items-center rounded-full border border-white/25 px-3.5 py-1.5 text-xs sm:text-sm text-white/90" data-id="element-62" data-mp="i08vw9c08zjv">
              {chip}
            </li>)}
          <li className="inline-flex items-center rounded-full bg-white/10 border border-white/25 px-3.5 py-1.5 text-xs sm:text-sm font-semibold" data-id="element-63" data-mp="822wpzhl27ip">
            all handled
          </li>
        </ul>

        <div className="mt-12 overflow-hidden rounded-2xl border border-white/20" data-id="element-64" data-mp="2sr8pqkpimks3">
          <div className="grid grid-cols-2" data-id="element-65" data-mp="2xsfyalzhfnzt">
            <p className="px-5 py-3 bg-white/5 text-xs font-bold uppercase tracking-[0.12em] text-white/60" data-id="element-66" data-mp="148xtbasnqpkx">
              Without the system
            </p>
            <p className="px-5 py-3 bg-white/10 text-xs font-bold uppercase tracking-[0.12em] text-white" data-id="element-67" data-mp="zacunft20dyl">
              With the system
            </p>
          </div>
          {closeRows.map(row => <div key={row.before} className="grid grid-cols-2 border-t border-white/15" data-id="element-68" data-mp="pjrliyfr7r1f">
              <p className="px-5 py-4 text-[14px] sm:text-[15px] leading-relaxed text-white/60" data-id="element-69" data-mp="gjcxhrbenxu8">
                {row.before}
              </p>
              <p className="px-5 py-4 text-[14px] sm:text-[15px] leading-relaxed text-white font-medium bg-white/5 border-l border-white/15" data-id="element-70" data-mp="blbet7hw60ja">
                {row.after}
              </p>
            </div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-71" data-mp="25xi0x1cbq1qd">
          <p className="font-serif text-lg sm:text-xl" data-id="element-72" data-mp="20yoqjhsc2quf">
            Homeschool, Handled. — 6 volumes + 5 bonuses
          </p>
          <p className="mt-2 text-white/75 text-sm sm:text-base" data-id="element-73" data-mp="28hxx739ggbfs">
            <span className="line-through" data-id="element-74" data-mp="2dhajnmwezghu">{REGULAR_PRICE}</span> → {PRICE} USD
            · one-time · lifetime access · Letter + A4
          </p>

          {urgency === 'launch-price' && <p className="mt-3 text-sm text-white/70" data-id="element-75" data-mp="2n7c7qeoroywr">
              Launch price until {LAUNCH_PRICE_ENDS}, then{' '}
              {PRICE_AFTER_LAUNCH}.
            </p>}

          <CtaButton href={CHECKOUT_URL} className="mt-7 bg-white text-sage hover:bg-cream hover:text-sage-dark" data-id="element-76" data-mp="1pm7rb4yeiuwm">
            Yes, I want Homeschool, Handled.
          </CtaButton>

          <ul className="mt-7 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs sm:text-sm text-white/75 font-medium" data-id="element-77" data-mp="24gulmsyfx1kd">
            <li className="flex items-center gap-1.5" data-id="element-78" data-mp="3aw4x1savw8ie">
              <LockIcon className="w-4 h-4" aria-hidden="true" data-id="element-79" data-mp="3azj2j9eugxu2" />
              100% secure checkout
            </li>
            <li className="flex items-center gap-1.5" data-id="element-80" data-mp="3dhclev2elxtc">
              <ZapIcon className="w-4 h-4" aria-hidden="true" data-id="element-81" data-mp="3dhw80p301adp" />
              Instant access
            </li>
            <li className="flex items-center gap-1.5" data-id="element-82" data-mp="39i3vy2eecm3l">
              <ShieldCheckIcon className="w-4 h-4" aria-hidden="true" data-id="element-83" data-mp="3ngtrvephcfqd" />
              {GUARANTEE_DAYS}-day guarantee
            </li>
          </ul>
        </div>
      </div>
    </section>;
}